export * from './lib/utils-dictionaries.module';
export { WordingService } from './lib/wording.service';
